import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 13,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPanel: {
    width: '100%',
    // overflowX: 'auto'/,
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsContainer: {
    // overflowX: 'auto', // ✅ Scroll allow karega
    whiteSpace: 'nowrap', // ✅ Tabs wrap hone ki jagah scroll hoga
    width: '100%',
    display: 'flex',
  },
  tabs: {
    width: 'max-content',
    minWidth: '100%',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
}));
